import React, { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BookingCTA } from "./MarketingPrimitives";
import "./Navbar.css";

const navItems = [
  { label: "Product", path: "/product" },
  { label: "Services", path: "/services" },
  { label: "For CROs", path: "/home", hash: "#for-cros" },
  { label: "For Founders", path: "/home", hash: "#for-founders" },
  { label: "Use Cases", path: "/usecases" },
  { label: "Value Creation Teams", path: "/valuecreationteams" },
  { label: "About", path: "/aboutus" },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const homePath = useMemo(
    () => location.pathname === "/" || location.pathname === "/home",
    [location.pathname]
  );
  const currentSourcePage = useMemo(() => {
    if (homePath && location.hash === "#for-cros") {
      return "for_cros";
    }
    if (homePath && location.hash === "#for-founders") {
      return "for_founders";
    }
    if (homePath && location.hash === "#book-demo") {
      return "book_demo";
    }
    if (location.pathname === "/") {
      return "home";
    }
    return location.pathname.replace(/^\/+/, "").replace(/-/g, "_") || "home";
  }, [homePath, location.hash, location.pathname]);

  function handleNavigate(path, hash = "") {
    navigate(`${path}${hash}`);
    setIsMenuOpen(false);
  }

  function isItemActive(item) {
    if (item.hash) {
      return homePath && location.hash === item.hash;
    }

    return location.pathname === item.path;
  }

  return (
    <header className="site-header">
      <div className="site-header-shell">
        <button
          type="button"
          className="brand-link"
          onClick={() => handleNavigate("/home")}
          aria-label="Go to BestSalesCoach.ai home"
        >
          <img src="/bestsalescoach-logo.jpg" alt="BestSalesCoach.ai" className="site-logo" />
          <span className="brand-text-wrap">
            <span className="brand-title">BestSalesCoach.ai</span>
            <span className="brand-subtitle">AI GTM Execution Intelligence</span>
          </span>
        </button>

        <button
          type="button"
          className="nav-toggle"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`site-nav ${isMenuOpen ? "is-open" : ""}`} aria-label="Primary">
          <ul className="site-nav-list">
            {navItems.map((item) => (
              <li key={item.label}>
                <Link
                  to={`${item.path}${item.hash || ""}`}
                  className={isItemActive(item) ? "site-nav-link active" : "site-nav-link"}
                  aria-current={isItemActive(item) ? "page" : undefined}
                  onClick={(event) => {
                    event.preventDefault();
                    handleNavigate(item.path, item.hash);
                  }}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li className="site-nav-cta-item">
              <BookingCTA
                className="nav-cta-button"
                eventName="book_demo_click"
                sourcePage={currentSourcePage}
                ctaClicked="book_20_min_demo"
                requestedOffer="BestSalesCoach.ai Platform Demo"
                buyerType="General"
                urlType="demo"
                onClick={() => setIsMenuOpen(false)}
              />
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
